export class UserSetting {
  lang:string;
  entryClaims: boolean;
}
